import { FormControlLabel, RadioGroup, Radio } from "@mui/material";
import { useTranslations } from "use-intl";

import { TripType } from "@/features/flights/types/types";

type TripTypeRadioGroupProps = {
  value: TripType;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: TripType,
  ) => void;
};

export function TripTypeRadioGroup({
  value,
  onChange,
}: TripTypeRadioGroupProps) {
  const t = useTranslations();

  return (
    <RadioGroup
      row
      aria-label={t("flights.search.tripType")}
      name="tripType"
      className="justify-center gap-6"
      value={value}
      onChange={(event, newValue) => onChange(event, newValue as TripType)}
    >
      <FormControlLabel
        value={TripType.ONE_WAY}
        control={<Radio />}
        label={t("flights.search.oneWay")}
      />
      <FormControlLabel
        value={TripType.ROUND_TRIP}
        control={<Radio />}
        label={t("flights.search.roundTrip")}
      />
    </RadioGroup>
  );
}
